export const setDepositInAccount = (principal, balance) => {
  if (principal === null || principal === undefined || balance === null || balance === undefined)
    return 0;
  return (principal > balance)? principal - balance: 0;
};
